// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"LeadMagnet_formWrapper__Jhpoa","bottom":"LeadMagnet_bottom__XjsxO","bottomButton":"LeadMagnet_bottomButton__kXLzI","closeBtn":"LeadMagnet_closeBtn__IQZCz"};